(function($) {

  $.fn.simpleMethod = function( options ) {
    settings = $.extend({
        action: '/',
        method: 'post'
    }, options);

    this
      .attr({
        action: settings.action,
        method: settings.method
      })
      .find('input[name="_method"]')
      .val(settings.method);
  };

})(jQuery);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/jquery.simple-method.js